module.exports = __webpack_public_path__ + "img/logo-horizontal-color-sm.4206d746.png";